module.exports = __webpack_public_path__ + "img/color.77afe32d.jpg";